import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";
import "./styles/layout.css";
import "./styles/forms.css";
import Busy from "./components/Busy";
import SideBar from "./components/ticketing/SideBar"; // Eager load
import FinanceSideBar from "./components/finance/FinanceSideBar"; // Eager load
import PasswordEmailSent from "./components/PasswordEmailSent";
import Profile from "./components/Profile";
import AkamaiInvoice from "./components/ticketing/AkamaiInvoice";

const ResetPasswordConfirm = lazy(() =>
  import("./components/ResetPasswordConfirm")
);
// Lazy-loaded components
const TravelItem = lazy(() => import("./components/finance/TravelItem"));
const Ticket = lazy(() => import("./components/ticketing/Ticket"));
const Supplier = lazy(() => import("./components/finance/Suppliers"));
const Clients = lazy(() => import("./components/ticketing/Clients"));
const Flights = lazy(() => import("./components/ticketing/Flights"));
const ViewTicket = lazy(() => import("./components/ticketing/ViewTicket"));
const NewBooking = lazy(() => import("./components/ticketing/NewBooking"));
const PostTicketEdit = lazy(() =>
  import("./components/ticketing/PostTicketEdit")
);
const Airline = lazy(() => import("./components/ticketing/Airline"));
const TicketUpdate = lazy(() => import("./components/finance/TicketUpdate"));
const Customers = lazy(() => import("./components/finance/Customers"));
const Invoice = lazy(() => import("./components/finance/Invoice"));
const ViewInvoice = lazy(() => import("./components/finance/ViewInvoice"));
const Quotation = lazy(() => import("./components/finance/Quotation"));
const PaymentDisplay = lazy(() =>
  import("./components/finance/PaymentDisplay")
);
const NewQuotation = lazy(() => import("./components/ticketing/NewQuotation"));
const ViewQuotationDocument = lazy(() =>
  import("./components/ticketing/ViewQuotationDocument")
);
const Proforma = lazy(() => import("./components/finance/Proforma"));
const EditInvoice = lazy(() => import("./components/finance/EditInvoice"));
const EditUpdatedTicket = lazy(() =>
  import("./components/finance/EditUpdatedTicket")
);
const EditProforma = lazy(() => import("./components/finance/EditProforma"));
const BalanceSheet = lazy(() => import("./components/finance/BalanceSheet"));
const IncomeStatement = lazy(() =>
  import("./components/finance/IncomeStatement")
);
const Ledgers = lazy(() => import("./components/finance/Ledgers"));
const BankReconciliation = lazy(() =>
  import("./components/finance/BankReconciliation")
);
const PostEditQuotation = lazy(() =>
  import("./components/ticketing/PostEditQuotation")
);
const Bills = lazy(() => import("./components/finance/Bills"));
const CreditNote = lazy(() => import("./components/finance/CreditNote"));
const Expenses = lazy(() => import("./components/finance/Expenses"));
const Amadeus = lazy(() => import("./components/ticketing/Amadeus"));
const AuditTrail = lazy(() => import("./components/finance/AuditTrail"));
const DebitNote = lazy(() => import("./components/finance/DebitNote"));
const JournalEntry = lazy(() => import("./components/finance/JournalEntry"));
const CustomerStatement = lazy(() =>
  import("./components/finance/CustomerStatement")
);
const SelectRole = lazy(() => import("./components/SelectRole"));
const ResetPassword = lazy(() => import("./components/ResetPassword"));
const Register = lazy(() => import("./components/Register"));
const Login = lazy(() => import("./components/Login"));
const Signup = lazy(() => import("./components/Signup"));

const FinanceDashboard = lazy(() =>
  import("./components/finance/FinanceDashboard")
);
const DashBoard = lazy(() => import("./components/ticketing/DashBoard"));

function App() {
  return (
    <Router>
      <Suspense fallback={<Busy />}>
        <Routes>
          <Route path="/role" element={<SelectRole />} />
          <Route path="/change_password" element={<ResetPassword />} />
          <Route path="/" element={<Register />}>
            <Route index element={<Login />} />
            <Route path="register" element={<Signup />} />
            <Route
              path="password_reset_email_sent"
              element={<PasswordEmailSent />}
            />
          </Route>
          <Route
            path="/password/reset/confirm/:uid/:token"
            element={
              <Suspense fallback={<Busy />}>
                <ResetPasswordConfirm />
              </Suspense>
            }
          />
          <Route path="ticketing" element={<SideBar />}>
            <Route
              index
              element={
                <Suspense fallback={<Busy />}>
                  <DashBoard />
                </Suspense>
              }
            />
            {/* <Route path="akamai" element={<AkamaiInvoice />} /> */}
            <Route
              path="home"
              element={
                <Suspense fallback={<Busy />}>
                  <DashBoard />
                </Suspense>
              }
            />
            <Route
              path="tickets"
              element={
                <Suspense fallback={<Busy />}>
                  <Ticket />
                </Suspense>
              }
            />
            <Route
              path="clients"
              element={
                <Suspense fallback={<Busy />}>
                  <Clients />
                </Suspense>
              }
            />
            <Route
              path="airline"
              element={
                <Suspense fallback={<Busy />}>
                  <Airline />
                </Suspense>
              }
            />
            <Route
              path="flights"
              element={
                <Suspense fallback={<Busy />}>
                  <Flights />
                </Suspense>
              }
            />
            <Route
              path="profile"
              element={
                <Suspense fallback={<Busy />}>
                  <Profile />
                </Suspense>
              }
            />
            <Route
              path="travel"
              element={
                <Suspense fallback={<Busy />}>
                  <TicketUpdate />
                </Suspense>
              }
            />
            <Route
              path="viewticket"
              element={
                <Suspense fallback={<Busy />}>
                  <ViewTicket />
                </Suspense>
              }
            />
            <Route
              path="newbooking"
              element={
                <Suspense fallback={<Busy />}>
                  <NewBooking />
                </Suspense>
              }
            />
            <Route
              path="edit_ticket"
              element={
                <Suspense fallback={<Busy />}>
                  <PostTicketEdit />
                </Suspense>
              }
            />
            <Route
              path="quotation"
              element={
                <Suspense fallback={<Busy />}>
                  <NewQuotation />
                </Suspense>
              }
            />
            <Route
              path="edit-quotation"
              element={
                <Suspense fallback={<Busy />}>
                  <PostEditQuotation />
                </Suspense>
              }
            />
            <Route
              path="proforma"
              element={
                <Suspense fallback={<Busy />}>
                  <Proforma />
                </Suspense>
              }
            />
            <Route
              path="viewquotation"
              element={
                <Suspense fallback={<Busy />}>
                  <ViewQuotationDocument />
                </Suspense>
              }
            />
            <Route
              path="amadeus"
              element={
                <Suspense fallback={<Busy />}>
                  <Amadeus />
                </Suspense>
              }
            />
          </Route>

          <Route path="finance" element={<FinanceSideBar />}>
            <Route
              index
              element={
                <Suspense fallback={<Busy />}>
                  <FinanceDashboard />
                </Suspense>
              }
            />
            <Route
              path="home"
              element={
                <Suspense fallback={<Busy />}>
                  <FinanceDashboard />
                </Suspense>
              }
            />
            <Route
              path="invoices"
              element={
                <Suspense fallback={<Busy />}>
                  <Invoice />
                </Suspense>
              }
            />
            <Route
              path="profile"
              element={
                <Suspense fallback={<Busy />}>
                  <Profile />
                </Suspense>
              }
            />
            <Route
              path="customers"
              element={
                <Suspense fallback={<Busy />}>
                  <Customers />
                </Suspense>
              }
            />
            <Route
              path="payments"
              element={
                <Suspense fallback={<Busy />}>
                  <PaymentDisplay />
                </Suspense>
              }
            />
            <Route
              path="travel"
              element={
                <Suspense fallback={<Busy />}>
                  <TicketUpdate />
                </Suspense>
              }
            />
            <Route
              path="viewinvoice"
              element={
                <Suspense fallback={<Busy />}>
                  <ViewInvoice />
                </Suspense>
              }
            />
            <Route
              path="quotation"
              element={
                <Suspense fallback={<Busy />}>
                  <Quotation />
                </Suspense>
              }
            />
            <Route
              path="travelitem"
              element={
                <Suspense fallback={<Busy />}>
                  <TravelItem />
                </Suspense>
              }
            />
            <Route
              path="newquotation"
              element={
                <Suspense fallback={<Busy />}>
                  <NewQuotation />
                </Suspense>
              }
            />
            <Route
              path="proforma"
              element={
                <Suspense fallback={<Busy />}>
                  <Proforma />
                </Suspense>
              }
            />
            <Route
              path="sales"
              element={
                <Suspense fallback={<Busy />}>
                  <Ticket />
                </Suspense>
              }
            />
            <Route
              path="edit_invoice"
              element={
                <Suspense fallback={<Busy />}>
                  <EditInvoice />
                </Suspense>
              }
            />
            <Route
              path="edit_ticket"
              element={
                <Suspense fallback={<Busy />}>
                  <EditUpdatedTicket />
                </Suspense>
              }
            />
            <Route
              path="edit_proforma"
              element={
                <Suspense fallback={<Busy />}>
                  <EditProforma />
                </Suspense>
              }
            />
            <Route
              path="balance_sheet"
              element={
                <Suspense fallback={<Busy />}>
                  <BalanceSheet />
                </Suspense>
              }
            />
            <Route
              path="income_statement"
              element={
                <Suspense fallback={<Busy />}>
                  <IncomeStatement />
                </Suspense>
              }
            />
            <Route
              path="customer_statement"
              element={
                <Suspense fallback={<Busy />}>
                  <CustomerStatement />
                </Suspense>
              }
            />
            <Route
              path="bills"
              element={
                <Suspense fallback={<Busy />}>
                  <Bills />
                </Suspense>
              }
            />
            <Route
              path="expenses"
              element={
                <Suspense fallback={<Busy />}>
                  <Expenses />
                </Suspense>
              }
            />
            <Route
              path="credit_notes"
              element={
                <Suspense fallback={<Busy />}>
                  <CreditNote />
                </Suspense>
              }
            />
            <Route
              path="debit-notes"
              element={
                <Suspense fallback={<Busy />}>
                  <DebitNote />
                </Suspense>
              }
            />
            <Route
              path="suppliers"
              element={
                <Suspense fallback={<Busy />}>
                  <Supplier />
                </Suspense>
              }
            />
            <Route
              path="journals"
              element={
                <Suspense fallback={<Busy />}>
                  <JournalEntry />
                </Suspense>
              }
            />
            <Route
              path="bank_reconciliation"
              element={
                <Suspense fallback={<Busy />}>
                  <BankReconciliation />
                </Suspense>
              }
            />
            <Route
              path="audit"
              element={
                <Suspense fallback={<Busy />}>
                  <AuditTrail />
                </Suspense>
              }
            />
            <Route
              path="ledgers"
              element={
                <Suspense fallback={<Busy />}>
                  <Ledgers />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
